export const storePropList = [
  {
    label: "经销商",
    prop: "customerName",
    align: "center",
  },
  {
    label: "门店",
    prop: "storeName",
    align: "center",
  },
  {
    label: "参与时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "浏览次数",
    prop: "browseNumber",
    width: "80",
    align: "center",
  },
  {
    label: "浏览人数",
    prop: "browsePeopleNumber",
    width: "80",
    align: "center",
  },
  {
    label: "参与职员数",
    prop: "joinStaffNum",
    width: "100",
    align: "center",
  },
  {
    label: "操作",
    width: "130",
    align: "center",
    slotName: "viewEmployees",
  },
];

export const signUpPropList = [
  {
    label: "用户姓名",
    prop: "joinUserName",
    align: "center",
    width: "160",
  },
  {
    label: "联系方式",
    prop: "userPhone",
    align: "center",
    width: "160",
  },
  {
    label: "参与时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
    width: "160",
  },
  {
    label: "金额(元)",
    prop: "joinActivityAmount",
    width: "160",
    align: "center",
  },
  {
    label: "状态",
    prop: "signupStatus",
    width: "160",
    align: "center",
    slotName: "status",
  },
  {
    label: "分享门店",
    prop: "storeName",
    width: "160",
    align: "center",
  },
  {
    label: "分享职员",
    prop: "staffName",
    width: "160",
    align: "center",
    slotName: "shareEmployees"
  },
  {
    label: "核销门店",
    prop: "verificationStoreName",
    width: "160",
    align: "center",
  },
  {
    label: "核销职员",
    prop: "verificationStaffName",
    width: "160",
    align: "center",
    slotName: "verificationPersonnel"
  },
];

export const luckdrawPropList = [
  {
    label: "微信昵称",
    prop: "wxNickName",
    align: "center",
    width: "160",
  },
  {
    label: "抽奖时间",
    prop: "lotteryDate",
    slotName: "time",
    align: "center",
    width: "160",
  },
  {
    label: "抽奖结果",
    prop: "winningExcel",
    align: "center",
    width: "160",
  },

  {
    label: "兑奖码",
    prop: "exchangeCode",
    width: "160",
    align: "center",
  },
  {
    label: "兑奖状态",
    prop: "statusExcel",
    width: "160",
    align: "center",
  },
  {
    label: "兑奖方式",
    prop: "exchangeTypeExcel",
    align: "center",
  },
  {
    label: "兑奖时间",
    prop: "exchangeDate",
    slotName: "time",
    align: "center",
    width: "160",
  },
  {
    label: "兑奖人",
    prop: "exchangeUser",
    width: "160",
    align: "center",
    slotName: "verificationPersonnel"
  },
  {
    label: "兑奖门店",
    prop: "exchangeStore",
    width: "160",
    align: "center",
  },
];

export const seckillPropList = [
  {
    label: "用户名称",
    prop: "contactsName",
    align: "center",
  },
  {
    label: "联系方式",
    prop: "contactsPhone",
    align: "center",
  },
  {
    label: "秒杀时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "商品名称",
    prop: "goodsName",
    align: "center",
  },
  {
    label: "金额（元）",
    prop: "goodsPrice",
    align: "center",
    width: "160",
  },

  {
    label: "状态",
    prop: "status",
    align: "center",
  },
  {
    label: "分享门店",
    prop: "shareShop",
    align: "center",
  },
  {
    label: "分享职员",
    prop: "shareStaff",
    align: "center",
  },
  {
    label: "核销门店",
    prop: "verificationStoreName",
    align: "center",
  },
  {
    label: "核销职员",
    prop: "verificationStaffName",
    align: "center",
  },
];

export const awardsArrPropList = [
  {
    label: "奖品类型",
    prop: "awardTypeExcel",
    align: "center",
  },
  {
    label: "名称",
    prop: "awardName",
    align: "center",
  },
  {
    label: "创建时间",
    prop: "createdTime",
    align: "center",
    slotName: "time",
    width: "160",
  },

  {
    label: "中奖概率",
    prop: "winProbabilityExcel",
    align: "center",
  },
  {
    label: "数量",
    prop: "awardNumber",
    align: "center",
  },
  {
    label: "发放量",
    prop: "sendCount",
    align: "center",
  },
  {
    label: "状态",
    prop: "statusExcel",
    align: "center",
  },
];

export const goodsPropList = [
  {
    label: "名称",
    prop: "productName",
    align: "center",
  },
  {
    label: "原价（元）",
    prop: "oldPrice",
    align: "center",
  },
  {
    label: "秒杀定金",
    prop: "preSpikePrice",
    align: "center",
  },

  {
    label: "销售价（元）",
    prop: "spikePriceValue",
    align: "center",
  },
  {
    label: "虚拟库存",
    prop: "virtualProductNumber",
    align: "center", 
    
  },
  {
    label: "库存",
    prop: "productNumber",
    align: "center",
    
  },
  {
    label: "销售量",
    prop: "salesCount",
    align: "center",
  },
  {
    label: "最后一次编辑时间",
    prop: "lastEditTime",
    align: "center",
    slotName: "time",
    width: "150"
  },
  {
    label: "状态",
    prop: "status",
    align: "center",
  },
];

export const sessionsPropList = [
  {
    label: "开始时间",
    prop: "startTime",
    align: "center",
    slotName: "time",
  },
  {
    label: "截止时间",
    prop: "endTime",
    align: "center",
    slotName: "time",
  },
  {
    label: "商品数",
    prop: "goodsCount",
    align: "center",
  },
  {
    label: "销售量",
    prop: "salesCount",
    align: "center",
  },
  {
    label: "当前状态",
    prop: "status",
    align: "center",
  },
  {
    label: "操作",
    prop: "winProbabilityExcel",
    align: "center",
    slotName: "handle",
  },
];

export const answersPropList = [
  {
    label: "微信昵称",
    prop: "customerName",
    align: "center",
    width: "160",
  },
  {
    label: "问答时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
    width: "160",
  },
  {
    label: "分享门店",
    prop: "shareStoreName",
    align: "center",
  },

  {
    label: "分享职员",
    prop: "h5UserName",
    align: "center",
  },
  {
    label: "挑战状态",
    prop: "boolSuccessExcel",
    width: "160",
    align: "center"
  },
  {
    label: "正确数",
    prop: "rightNum",
    align: "center",
    width: "160",
  },
  {
    label: "成绩(当时)",
    prop: "challengeScore",
    align: "center",
    width: "160",
  },
  {
    label: "每道题分值(当时)",
    prop: "scorePerQuestion",
    align: "center",
    width: "160",
  },
];

export const groupPropList = [
  {
    label: "顾客名称",
    prop: "contactsName",
    align: "center",
  },
  {
    label: "拼团时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "商品名称",
    prop: "goodsName",
    align: "center",
  },

  {
    label: "分享门店",
    prop: "storeName",
    align: "center",
  },
  {
    label: "分享职员",
    prop: "h5UserName",
    align: "center"
  },
  {
    label: "拼团状态",
    prop: "teamStatusExcel",
    align: "center",
  },
  {
    label: "实付价格(元)",
    prop: "goodsPrice",
    align: "center",
  },
  {
    label: "状态",
    prop: "statusExcel",
    align: "center",
  },
];

export const groupPropGoodsLis = [
  {
    label: "名称",
    prop: "goodsName",
    align: "center",
  },
  {
    label: "原价(元)",
    prop: "oldPrice",
    align: "center",
    width: "120",
  },
  {
    label: "自定义字段",
    prop: "groupBuyTitle",
    align: "center",
  },

  {
    label: "销售价(元)",
    prop: "groupBuyPrice",
    align: "center",
    width: "120",
  },
  {
    label: "成团人数",
    prop: "teamNumber",
    align: "center",
    width: "120"
  },
  {
    label: "当前库存",
    prop: "goodsSurplusNumber",
    align: "center",
    width: "120",
  },
  {
    label: "销售量",
    prop: "soldNumber",
    align: "center",
    width: "100",
  },
  {
    label: "最后一次编辑时间",
    prop: "updatedTime",
    align: "center",
  },
  {
    label: "状态",
    prop: "statusExcel",
    align: "center",
    width: "100",
  },
];

export const groupPropNumberList = [
  {
    label: "团长",
    prop: "customerName",
    align: "center",
  },
  {
    label: "开团时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "商品名称",
    prop: "goodsName",
    align: "center",
  },

  {
    label: "分享门店",
    prop: "storeName",
    align: "center",
  },
  {
    label: "分享职员",
    prop: "h5UserName",
    align: "center"
  },
  {
    label: "拼团状态",
    prop: "statusExcel",
    align: "center",
    width: "120",
  },
  {
    label: "成团数",
    prop: "teamNumber",
    align: "center",
    width: "120",
  },
  {
    label: "团员数",
    prop: "joinNumber",
    align: "center",
    width: "120",
  },
  {
    label: "实付价格",
    prop: "goodsPrice",
    align: "center",
  },
];

export const drawLotsSign = [
  {
    label: "内容",
    prop: "name",
    align: "center",
  },
  {
    label: "编辑时间",
    prop: "updatedTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "数量",
    prop: "drawLotsNumber",
    align: "center",
  },

  {
    label: "当前库存",
    prop: "surplusNum",
    align: "center",
  },
  {
    label: "获得概率",
    prop: "drawLotsProb",
    align: "center"
  },
  {
    label: "状态",
    prop: "status",
    align: "center",
    width: "120",
  }
]; 

export const drawLotsDetail = [
  {
    label: "奖品类型",
    prop: "prizeTypeStr",
    align: "center",
  },
  {
    label: "名称",
    prop: "prizeName",
    align: "center",
  },
  {
    label: "编辑时间",
    prop: "updatedTime",
    align: "center",
  },

  {
    label: "数量",
    prop: "inventory",
    align: "center",
  },
  {
    label: "兑换数",
    prop: "exchangeNum",
    align: "center"
  },
  {
    label: "兑换条件",
    prop: "exchangeConditions",
    align: "center",
    width: "120",
  },
  {
    label: "状态",
    prop: "status",
    align: "center",
    width: "120",
  }
];

export const drawLotsDrawLots = [
  {
    label: "编码",
    prop: "id",
    align: "center",
  },
  {
    label: "奖品类型",
    prop: "prizeType",
    align: "center",
  },
  {
    label: "名称",
    prop: "prizeName",
    align: "center",
  },

  {
    label: "兑奖时间",
    prop: "createdTime",
    align: "center",
  },
  {
    label: "兑换人",
    prop: "contactsName",
    align: "center"
  },
  {
    label: "手机号",
    prop: "contactsPohone",
    align: "center",
    width: "120",
  },
  {
    label: "省市区",
    prop: "province",
    align: "center",
    width: "120",
  },
  {
    label: "详细地址",
    prop: "address",
    align: "center",
    width: "120",
  },
  {
    label: "运单号",
    prop: "expressNo",
    align: "center",
    width: "120",
  }
];

export const drawLotsData = [
  {
    label: "签",
    prop: "drawName",
    align: "center",
  },
  {
    label: "抽取时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "用户昵称",
    prop: "name",
    align: "center",
  }
];


export const countMoneyDetailData = [
  {
    label: "奖品类型",
    prop: "prizeType",
    align: "center"
  },
  {
    label: "名称",
    prop: "prizeName",
    align: "center",
  },
  {
    label: "编辑时间",
    prop: "updatedTime",
    align: "center",
    width: '160'
  },
  {
    label: "数量",
    prop: "prizeCount",
    align: "center",
  },
  {
    label: "领取方式",
    prop: "receiveMethod",
    align: "center",
  },
  {
    label: "获奖方式",
    prop: "rewardMechanism",
    align: "rewardMechanism",
  }
]

export const countMoneyData = [
  {
    label: "用户名称",
    prop: "customerName",
    align: "center",
  },
  {
    label: "参与时间",
    prop: "createdTime",
    slotName: "time",
    align: "center",
  },
  {
    label: "数钱次数",
    prop: "times",
    align: "center",
  },
  {
    label: "全国排名名次",
    prop: "allRankNo",
    align: "center",
    sortable: "custom"
  },
  {
    label: "省区排名名次",
    prop: "orgRankNo",
    align: "center",
    sortable: "custom"
  },
  {
    label: "中奖数量",
    prop: "winTimes",
    align: "center",
    
  },
  {
    label: "手机号",
    prop: "phone",
    align: "center",
    
  },
  {
    label: "操作",
    prop: "name",
    align: "center",
    slotName: "handle",
  }
];


export const couponDetail = [
  {
    label: "优惠券名称",
    prop: "couponName",
    align: "center",
  },
  {
    label: "优惠券面值",
    prop: "couponFaceValue",
    align: "center",
    width: '100'
  },
  {
    label: "使用门槛",
    prop: "useDoorsill",
    align: "center",
    showOverflowTooltip: true
  },

  {
    label: "优惠券总数量",
    prop: "couponSum",
    align: "center",
    width: 120
  },
  {
    label: "每人最多领取数量",
    prop: "everyoneMaxGetNumber",
    align: "center",
    width: 140
  },
  {
    label: "使用规则",
    prop: "useRule",
    align: "center",
    showOverflowTooltip: true
  },
  {
    label: "剩余数量",
    prop: "residueNum",
    align: "center",
    width: 100
  }
];

export const couponTabData = [
  {
    label: "用户名称",
    prop: "customerName",
    align: "center",
  },
  {
    label: "领券时间",
    prop: "createdTime",
    align: "center",
  },
  {
    label: "优惠券名称",
    prop: "couponName",
    align: "center",
  },

  {
    label: "优惠券面值",
    prop: "couponFaceValue",
    align: "center",
  },
  {
    label: "使用门槛",
    prop: "useDoorsill",
    align: "center"
  },
  {
    label: "状态",
    prop: "statusName",
    align: "center",
    width: "120",
  },
  {
    label: "分享门店",
    prop: "storeName",
    align: "center",
    width: "120",
  },
  {
    label: "分享职员",
    prop: "h5UserName",
    align: "center",
    width: "120",
  },
  {
    label: "核销门店",
    prop: "verificationStoreName",
    align: "center",
    width: "120",
  },
  {
    label: "核销职员",
    prop: "h5UserName",
    align: "center",
    width: "120",
  },
  {
    label: "核销时间",
    prop: "verificationTime",
    align: "center",
    width: "120",
  }
];


